import { encodeFunctionData, erc20Abi } from 'viem'

export const maxUint256 = BigInt(
	'0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
)

export function encodeErc20Transfer(to: string, amount: bigint): `0x${string}` {
	return encodeFunctionData({
		abi: erc20Abi,
		functionName: 'transfer',
		args: [to as `0x${string}`, amount],
	})
}

export function encodeErc20Approve(spender: string, amount: bigint = maxUint256): `0x${string}` {
	return encodeFunctionData({
		abi: erc20Abi,
		functionName: 'approve',
		args: [spender as `0x${string}`, amount],
	})
}
